import { IError, IQueryHookOptions } from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { deleteConsent } from 'services';

type DeleteConsentFunction = UseMutateAsyncFunction<
  { success: boolean },
  IError
>;

type UseDeleteConsent = [DeleteConsentFunction, IQueryHookOptions];

export const useDeleteConsent = (profileId = ''): UseDeleteConsent => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    { success: boolean },
    IError
  >(() => deleteConsent(profileId));

  return [mutateAsync, { error, isError, isLoading }];
};
